module.exports = {
  headerItems: {
    "acerca de nosotros": [
      ["nuestra historia", "our story"],
      ["sierra nevada", "sierra nevada"],
      ["estándares de calidad avicanna", "AVI standard of quality"],
    ],
    "nuestros productos": [
      ["línea de belleza", "beauty line"],
      ["humectación y protección", "moisture and protection"],
      ["cuidado especializado", "specialized care"],
    ],
    "Significado del CBD": [["Preguntas Frecuentes", "FAQ"]],
    "localizador de tiendas": [],
  },

  newsletter: "Newsletter",
  connectToUs: "Conéctate con nosotros",
  subscribeToOurNewsletter: "Suscríbete a nuestro boletín",
  ourStory: "Nuestra historia",
  ourProducts: "Nuestros productos",
  specialOffers: "Ofertas especiales",
  faqProducts: "Preguntas Frecuentes",
  contactUs: "Contáctenos",
  termsOfUse: "Términos de Uso",
  privacyPolicy: "Política de privacidad",
  accessibility: "Accesibilidad",
  submit: "Enviar",
  yourEmail: "tu email",
  newsletterText:
    "Nos alegra que hayas abierto tu mente a algo nuevo! Suscríbase utilizando su dirección de correo electrónico para mantenerse actualizado sobre lo último y lo mejor de Pura Earth.",
  welcomeTo: "Bienvenido a",
  emailAddress: "DIRECCIÓN DE EMAIL",
  seeMore: "Ver más",
  yourCart: "Tu Carrito de Compras",
  ViewOrderSummary: "Ver sumario de ordenes",
  noItemsInCart: "No tienes artículos en tu carrito.",
  startBrowsing: "Comienza a navegar!",
  ViewAllProducts: "Ver Todos Los Productos",
  subtotal: "Subtotal",
  shipping: "Envío",
  taxes: "Impuestos",
  checkout: "Continuar",
  remove: "Retirar",
  thanksForSubscribing:
    "Hola! Ahora estás suscrito. Gracias por unirte a la familia PuraEarth! Es hora de empezar a vivir la vida Pura Life. Espera nuestras noticias, actualizaciones y mucho más.",
  somethingWentWrong: "Algo salió mal",
  newsletterSubscribed:
    "Bienvenido a Pura Earth! Estamos felices de que estés aquí. Puede esperar recibir noticias y ofertas sobre nuestros productos.",
  newsletterFailure:
    "Lo sentimos, pero desafortunadamente no pudimos completar su suscripción. Inténtelo nuevamente en unos minutos.",
  continueShopping: "Continuar comprando",
  proceed: "proceder",
  followInstagram: "Síguenos en Instagram",
  redictingToPayU: "Redireccionando a PayU, por favor espere...",
  youAreBeingRedirected1: "Se le redirige a",
  youAreBeingRedirected2: "para completar la compra de forma segura.",
  yourTransaction: "La transacción ha sido aprobada",
  paymentReference: "Referencia de pago: ",
  followUpRef:
    "Con esta referencia puedes hacer seguimento a tu transaccion con nuestro equipo de sercivo al cliente.",
  otherProducts: "Otros productos",
  benefits: "Beneficios",
  securedPayments: "Pagos garantizados por",
  discover: "Descubrir",
  yourTransRejected: "Su transacción ha sido rechazada",
  rejectedPayment:
    "Desafortunadamente, su pago no pudo ser aceptado en este momento. Por favor verifique su información e intente nuevamente.",
  startExploring: "Empieza a explorar",
  splashCopyText:
    "We invite you to experience the unique beauty of nature and science brought together in Pura Earth skin care products.",
  yourTransactionPending: "Su transacción ha estado pendiente",
  PendingPayment:
    "Gracias por tu compra! Recibirá un correo electrónico una vez que se procese su pedido.",
  failedCheckout:
    "Lo sentimos, pero lamentablemente no pudimos realizar el pago. Por favor intente nuevamente en unos minutos.",
  outOfStock: "Currently out of stock",
  checkoutNotPermitted: "Can't proceed to payment",
  checkoutNotPermittedReason:
    "One or more of your items is out of stock. Please remove then and then proceed with your checkout.",
  checkoutDismissModal: "Close",
  outOfStock: "Actualmente no disponible",
  checkoutNotPermitted: "No se puede proceder al pago.",
  checkoutNotPermittedReason:
    "Uno o más de sus artículos están agotados. Elimine entonces y luego continúe con su pago.",
  checkoutDismissModal: "Cerrar",

  contactInformation: "Información del contacto",
  emailAddress: "DIRECCIÓN DE CORREO ELECTRÓNICO",
  enterValidEmail:
    "Por favor, introduce una dirección de correo electrónico válida",
  receiveNewsUpdates:
    "Me gustaría recibir noticias y actualizaciones sobre Pura Earth Products",
  shippingAddress: "Dirección de Envío",
  firstName: "PRIMER NOMBRE",
  enterFirstName: "Por favor ingrese un nombre",
  lastName: "APELLIDO",
  enterLastName: "Por favor ingrese un apellido",
  address: "DIRECCIÓN",
  enterAddress: "Por favor ingrese una direccion",
  ID: "DOCUMENTO DE IDENTIFICACIÓN (SOLO PARA COLOMBIA)",
  enterID: "Por favor ingrese una documento de identificación",
  enterApartment: "APARTAMENTO, SUITE, UNIDAD (OPCIONAL)",
  city: "CIUDAD",
  enterCity: "Por favor ingrese una ciudad",
  countryRegion: "PAÍS / REGIÓN",
  enterCountryRegion: "Por favor, introduzca un país / región",
  province: "PROVINCIA",
  enterProvince: "Por favor ingrese una provincia ",
  zipPostalCode: "CÓDIGO POSTAL / POSTAL",
  enterZipPostalCode: "Por favor, introduzca un código postal",
  phoneNumber: "NUMERO DE TELÉFONO (OPCIONAL)",
  billingAddress: "Dirección de Envio ",
  shippingAsBilling: "Use la dirección de envío como dirección de facturación",
  sameAddrShipping: "La misma dirección proporcionada para el envío",
  useDiffBilling: "Use una dirección de facturación diferente",
  continueShopping: "SEGUIR COMPRANDO",
  continueToPayment: "CONTINUAR AL PAGO",
  proceed: "PROCEDER",
  securePaymentsBy: "Pagos garantizados por",
  avicannaTOS: "© 2020 Avicanna Pura Earth",
  refTitle: "Referencias",
  termsOfUse: "Términos de Uso",
  privacyPolicy: "Política de privacidad",
  addToCart: "Añadir al carrito",
  addedToCart: "Agregado al carrito",
  quantity: "Cantitad",
  hasBeenAddedToCart: "ha sido agregado a tu carro",
  invalidEmail: "Email Inválido",
  pleaseEntervalidEmail: "Correo electrónico inválido",
  storeLocator: "localizador de tiendas",
  selectCityStore: "Seleccione una ciudad para mostrar tiendas",
  selectCity: "Selecciona una ciudad",
  lastUpdated: "Última actualización: ",
  termsOfUse: "Términos de Uso",
  notFoundTitle: "404 Página no encontrada",
  notFoundMessage:
    "Lo sentimos, no se puede encontrar la página que estaba buscando.",
  backHomepage: "Volver a la página principal",
  FAQ: "PREGUNTAS FRECUENTES",
  CC: "C.C. (Cédula de Ciudadanía)",
  CE: "C.E. (Cédula de Extranjería)",
  NIT: "NIT (Número de Identificación Tributaria)",
  passport: " Pasaporte",
  other: "Otro",
  outOfServiceTitle: "Estimado Cliente: ",
  outOfServiceContent:
    "Estamos haciendo cambios para que tengas una mejor experiencia de compra, por eso todo pedido que realices después del 18 de diciembre lo tendrás en tu casa a partir del 15 de enero.",
  merryChristmas: "Te deseamos una Feliz Navidad y un Próspero Año 2020.",
  selectACity: "Seleccione una ciudad",
  covidBanner: "Estimado cliente: Puede experimentar retrasos durante el envío de su pedido debido a  extraordinarias circunstancias como resultado del COVID-19.  Apreciamos su paciencia.",
  popupHeader:"obtén el 10%",
  discountHeader:"de descuento en tu primera compra",
  emailPlaceholder:"CORREO ELECTRÓNICO",
  checkbox:"Si, me gustaría recibir comunicados, actualizaciones y promociones de Pura Earth. Al suscribirme, reconozco que he leído y acepto los Términos de Servicio y Política de Privacidad, incluído el uso de cookies ",
  notChecked:"Por favor marque esta casilla si desea continuar",
  apply:"aplicar",
  duplicated:"¡Ya estás suscrito!",
  emailUsed:"Por favor ingrese otro correo electrónico",
  promoCode:"Promo Code",
  discount:"Descuento",
  wrongPromo:"Código de promoción no válido",
  noPromo:"Insertar código promocional",
  notEligible:"No eres elegible para usar este código promocional",
  usedPromo:"Usaste este código promocional antes",
  usedPromoEmailWarning:"Ingrese la dirección de correo electrónico para usar el código de promoción",
  receive:"RECIBE EN TU CORREO EL CÓDIGO DEL 10% DE DESCUENTO ESPECIAL ",
  unsubscribed:"Te has dado de baja de esta publicación.",
  resubscribe:"To re-subscribe, visit our website at",
  puraearth:"www.puraearth.com",
  locationAlertMsg:"Solo disponible en Colombia",

}
